import { cn } from '@/lib/utils';
import type { ItemStatus } from '@central/types';

const STATUS_META: Record<ItemStatus, { emoji: string; label: string; className: string }> = {
  'em-producao': { emoji: '🟢', label: 'Em produção', className: 'text-emerald-500' },
  publicado: { emoji: '🟢', label: 'Publicado', className: 'text-emerald-500' },
  'novo-revisar': { emoji: '🟡', label: 'Novo — revisar', className: 'text-amber-500' },
  rascunho: { emoji: '🟡', label: 'Rascunho', className: 'text-amber-500' },
  pausado: { emoji: '⚫', label: 'Pausado', className: 'text-zinc-500' },
  arquivado: { emoji: '⚫', label: 'Arquivado', className: 'text-zinc-500' },
  desaparecido: { emoji: '🔴', label: 'Desaparecido', className: 'text-red-500' },
};

export function ItemStatusBadge({ status, compact }: { status: ItemStatus; compact?: boolean }): JSX.Element {
  const meta = STATUS_META[status];
  if (compact) {
    return <span title={meta.label}>{meta.emoji}</span>;
  }
  return (
    <span className={cn('inline-flex items-center gap-1.5 text-xs', meta.className)}>
      <span>{meta.emoji}</span>
      <span>{meta.label}</span>
    </span>
  );
}

export const TIPO_LABELS: Record<string, string> = {
  'app-proprio': 'App Próprio',
  'app-aluno': 'App Aluno',
  'agente-autonomo': 'Agente Autônomo',
  'agente-loop': 'Agente Loop',
  dominio: 'Domínio',
  mentorada: 'Mentorada',
  skill: 'Skill',
  projeto: 'Projeto',
  doc: 'Doc',
  aula: 'Aula',
  curso: 'Curso',
  'termo-glossario': 'Termo do Glossário',
  lousa: 'Lousa',
};
